import React from 'react';

export default function UsersIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 25 18" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M17.6287 10.2712C19.17 11.3175 20.25 12.735 20.25 14.625V18H24.75V14.625C24.75 12.1725 20.7337 10.7212 17.6287 10.2712Z"
      />
      <path
        fill="currentColor"
        d="M9 9C11.4853 9 13.5 6.98528 13.5 4.5C13.5 2.01472 11.4853 0 9 0C6.51472 0 4.5 2.01472 4.5 4.5C4.5 6.98528 6.51472 9 9 9Z"
      />
      <path
        fill="currentColor"
        d="M15.75 9C18.2362 9 20.25 6.98625 20.25 4.5C20.25 2.01375 18.2362 0 15.75 0C15.2212 0 14.7262 0.1125 14.2537 0.27C15.1875 1.42875 15.75 2.9025 15.75 4.5C15.75 6.0975 15.1875 7.57125 14.2537 8.73C14.7262 8.8875 15.2212 9 15.75 9Z"
      />
      <path
        fill="currentColor"
        d="M9 10.125C5.99625 10.125 0 11.6325 0 14.625V18H18V14.625C18 11.6325 12.0038 10.125 9 10.125Z"
      />
    </svg>
  );
}
